// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"204":"231f19","288":"c5f28d"}[chunkId] + ".css";
};